import { defineContent, type DefinedContent } from '@post-office/define-content';

export const registeredContent: DefinedContent<
	[
		'back',
		'next',
		'done',
		'stepIndicator',
		'step1Headline',
		'step1Body',
		'step2Headline',
		'step2Body',
		'step3Headline',
		'step3Body',
	]
> = defineContent({
	default: {
		back: {
			id: 'confluence-ai-audio.scenario-changeboarding.backButton',
			defaultMessage: 'Back',
			description: 'Back button label in changeboarding spotlight',
		},
		next: {
			id: 'confluence-ai-audio.scenario-changeboarding.nextButton',
			defaultMessage: 'Next',
			description: 'Next button label in changeboarding spotlight',
		},
		done: {
			id: 'confluence-ai-audio.scenario-changeboarding.doneButton',
			defaultMessage: 'Done',
			description: 'Done button label in changeboarding spotlight',
		},
		stepIndicator: {
			id: 'confluence-ai-audio.scenario-changeboarding.stepIndicator',
			defaultMessage: '{currentStep} of {totalSteps}',
			description: 'Step indicator of changeboarding spotlight',
		},
		step1Headline: {
			id: 'confluence-ai-audio.scenario-changeboarding.step1Headline',
			defaultMessage: 'Save it',
			description: 'Headline for step 1 in scenario changeboarding',
			role: 'title',
		},
		step1Body: {
			id: 'confluence-ai-audio.scenario-changeboarding.step1Body',
			defaultMessage:
				'Not ready to listen? Add it to your playlist for later or play it on the app.',
			description: 'Body text for step 1 in scenario changeboarding',
			role: 'description',
		},
		step2Headline: {
			id: 'confluence-ai-audio.scenario-changeboarding.step2Headline',
			defaultMessage: 'Open playlist',
			description: 'Headline for step 2 in scenario changeboarding',
		},
		step2Body: {
			id: 'confluence-ai-audio.scenario-changeboarding.step2Body',
			defaultMessage: 'See what’s next, change the order, or start playing.',
			description: 'Body text for step 2 in scenario changeboarding',
		},
		step3Headline: {
			id: 'confluence-ai-audio.scenario-changeboarding.step3Headline',
			defaultMessage: 'Share it',
			description: 'Headline for step 3 in scenario changeboarding',
		},
		step3Body: {
			id: 'confluence-ai-audio.scenario-changeboarding.step3Body',
			defaultMessage: 'Copy and share a link so anyone with access can listen.',
			description: 'Body text for step 3 in scenario changeboarding',
		},
	},
});
